import { render, staticRenderFns } from "./Careplans.vue?vue&type=template&id=14fa9f38&scoped=true"
import script from "./Careplans.vue?vue&type=script&lang=js"
export * from "./Careplans.vue?vue&type=script&lang=js"
import style0 from "./Careplans.vue?vue&type=style&index=0&id=14fa9f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fa9f38",
  null
  
)

export default component.exports